
        import '/home/builduser/work/575538235ca6a4de/santa-editor/packages/pages/utils/components/newWorkspaceContentHeader.scss.css.virtualfile';
        module.exports = {"root":"_root_9a091_8","addPage":"_addPage_9a091_16"};